import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.abyss-table-root': {
    '.abyss-table-body': {
      '.abyss-table-row': {
        'td:last-child': {
          flex: 'none !important',
          minWidth: 'calc(100% - 20% - 48px) !important',
          width: 'calc(100% - 20% - 48px) !important',
        },
        'td:nth-of-type(2)': {
          flex: 'auto !important',
          minWidth: '20% !important',
          width: '20% !important',
        },
      },
    },
    '.abyss-table-head': {
      '.abyss-table-header': {
        'th:last-child': {
          flex: 'none !important',
          minWidth: 'calc(100% - 20% - 48px) !important',
          width: 'calc(100% - 20% - 48px) !important',
        },
        'th:nth-of-type(1)': {
          flex: 'auto !important',
          minWidth: '20% !important',
          width: '20% !important',
        },
      },
    },
  },
  '.hasActions': {
    '.abyss-table-root': {
      '.abyss-table-body': {
        '.abyss-table-row': {
          'td:last-child': {
            flex: 'none !important',
            minWidth: '148px !important',
            width: '148px !important',
          },
          'td:nth-of-type(3)': {
            flex: 'none !important',
            minWidth: 'calc(100% - 20% - 48px - 148px) !important',
            width: 'calc(100% - 20% - 48px - 148px) !important',
          },
        },
      },
      '.abyss-table-head': {
        '.abyss-table-header': {
          'th:last-child': {
            flex: 'none !important',
            minWidth: '148px !important',
            width: '148px !important',
          },
          'th:nth-of-type(3)': {
            flex: 'none !important',
            minWidth: 'calc(100% - 20% - 48px - 148px) !important',
            width: 'calc(100% - 20% - 48px - 148px) !important',
          },
        },
      },
    },
  },
});
